import Cookies from 'js-cookie';

/**
 * CookieBanner component.
 */
export default class CookieBanner {
  /**
   * Start the component
   */
  constructor({ element, children, options }) {
    this.element = element;
    this.children = children;
    this.options = options;

    // Bind class methods.
    this.init = this.init.bind(this);
    this.handleButtonClick = this.handleButtonClick.bind(this);

    const { sitePrefix } = amScripts.global;
    const prefix = (sitePrefix === 'snhs') ? 'sn' : sitePrefix;

    /**
     * The cookie name.
     *
     * @type {String}
     */
    this.cookieName = `${prefix}-cookies-accepted`;

    if (Cookies.get(this.cookieName) !== 'true') {
      this.init();
    }
  }

  /**
   * Set the cookie and hide the banner when the "Continue" button is clicked.
   */
  handleButtonClick() {
    Cookies.set(this.cookieName, true, { expires: 365 });

    this.element.setAttribute('hidden', '');
    this.element.setAttribute('aria-hidden', 'true');
  }

  /**
   * Initialize the component.
   */
  init() {
    const { button } = this.children;

    // Show the cookie banner.
    this.element.removeAttribute('hidden');
    this.element.removeAttribute('aria-hidden');

    button.addEventListener('click', this.handleButtonClick);
  }
}
